import { ILoginAndProfileService } from '@/shared/types/services/types/loginAndProfile/loginAndProfileTypes'
import { isStreamIQ, isToya } from '@/shared/lib'

export const getLoginAndProfileContainer = async () => {
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/services/containers/LoginAndProfileService/LoginAndProfileService')
            return module.default as ILoginAndProfileService
        } catch (error) {
            console.warn(
                'ILoginAndProfileService module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/services/containers/LoginAndProfileService/LoginAndProfileServiceStreamIQ')
            return module.default as ILoginAndProfileService
        } catch (error) {
            console.warn(
                'ILoginAndProfileService module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
